import {
  FilterKey,
  HandleChangeFilter,
} from '@/components/common/table-filter';
import { defineComponent, reactive, SetupContext } from '@vue/composition-api';

type Value = string | number;

type Props = {
  name: FilterKey;
  item: {
    value: Value;
    validate?: (value: Value) => boolean;
    options: {
      label: string;
      value: Value;
    };
  };
  onChange: HandleChangeFilter;
};

export default defineComponent({
  setup(_, ctx: SetupContext) {
    const state = reactive({
      searchText: '',
    });

    const props = {
      ...ctx.attrs,
      onChange: ctx.attrs['on-change'],
    } as Props;

    const handleChange = (value: Value) => {
      props.onChange(props.name, value);
    };

    return { ...props, state, handleChange };
  },
});
